import _ from "lodash";
import actions from "../actions/full.public";
import api_actions from "../actions/api";

import axios from "axios";
import {cleanPostcodeErrors, mapPostcodes} from "../../utils/redux.utils";

const updateState = (_state, action, new_data, name = null) => {
    let state = {..._state};
    if (!name) return state;
    state = {...state, ...new_data};
    return state;
};

const actionHandlers = {
    [actions.full_public_send_data]: (state, action) => {
        axios.defaults.withCredentials = false;
        const {name} = action;
        switch (action.payload) {
            case api_actions.api_start:
                return updateState(
                    state,
                    action,
                    {isLoading: true, errors: {}, vrmErrors: {}, postcodeErrors: {}, message: ''},
                    name
                );
            case api_actions.api_end:
                return updateState(state, action, {isLoading: false}, name);
            default:
                return state;
        }
    },
    [actions.full_public_initial_data_succeeded]: (state, action, name) => {
        const {
            uuid,
            sources,
            lead_details: lead_data,
            state: lead_state,
            message,
        } = action.payload;
        const _sources = sources ? sources : state.sources;

        return updateState(
            state,
            action,
            {
                uuid,
                sources: _sources,
                lead_state,
                errors: {},
                vrmErrors: {},
                postcodeErrors: {},
                message,
            },
            name,
            lead_data
        );
    },
    [actions.full_public_failed]: (state, action) => {
        const {name} = action;
        let errors = _.get(action, "payload.data.error");
        return updateState(
            state,
            action,
            {errors: !_.isEmpty(errors) ? errors : "Please try later"},
            name
        );
    },
    [actions.postcode_search]: (state, action) => {
        const {name} = action;
        switch (action.payload) {
            case api_actions.api_start:
                return updateState(
                    state,
                    action,
                    {postcodeIsLoading: true, postcodeErrors: {}},
                    name
                );
            case api_actions.api_end:
                return updateState(state, action, {postcodeIsLoading: false}, name);
            default:
                return state;
        }
    },
    [actions.postcode_failed]: (state, action) => {
        const {name} = action;
        const errors = _.get(action, "payload.data.error");
        const error = !_.isEmpty(errors) ? errors : 'Our postcode lookup service is down, please enter manually';
        const formErrors = cleanPostcodeErrors(_.get(state, 'errors', {}))

        return updateState(
            state,
            action,
            {
                postcodeErrors: error,
                mappedPostcodes: [],
                errors: {...formErrors, postcode: error}
            },
            name
        );
    },
    [actions.postcode_succeeded]: (state, action) => {
        const {name} = action;
        const mappedPostcodes = mapPostcodes(action.payload)
        const errors = cleanPostcodeErrors(_.get(state, 'errors', {}))
        return updateState(
            state,
            action,
            {
                postcodeData: action.payload,
                mappedPostcodes,
                errors,
                postcodeErrors: {}
                },
            name
        );
    },
    [actions.reset]: () => {
        return getDefaults();
    },
};

const fullPublicFormReducer = (formName = "") => {
    return function form(state = getDefaults(), action) {
        const {name} = action;

        if (name !== formName) return state;
        if (actionHandlers[action.type])
            return actionHandlers[action.type](state, action, name);
        return state;
    };
};

export function getDefaults() {
    return {};
}

export default fullPublicFormReducer;
